/*
 * Filename: cq-template-list.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';
import { ITemplate } from '../../interfaces/ITemplate';
import { values } from 'mobx';

const CQTemplateItem = types.model({
    name: types.string,
    label: types.string,
    description: types.string,
    inputParams: types.frozen({}),
    compilationOptions: types.frozen({})
});



/** 
 * @description TemplateListModel
 */
export const CQTemplateListModel = types.model({
    templates: types.array(CQTemplateItem),
    selectedTemplate: types.frozen({}),

}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
    setTemplates(templates: ITemplate[]) {
        self.templates = templates;
    },
    setSelectedTemplate(template: ITemplate) {
        self.selectedTemplate = template;
    },
    getDeployedTemplate(){
        return self.selectedTemplate;
    },
    getSelectedTemplate() {
        const selectedTemplate = values(self);
        return selectedTemplate[1].selectedTemplate;
    },
    setFieldsData(fieldKey: string, fieldValue: string) {
        if (self.selectedTemplate[1].selectedTemplate && self.selectedTemplate[1].selectedTemplate.inputParams) {
            self.selectedTemplate[1].selectedTemplate.inputParams[fieldKey] = fieldValue;
        }
    }
}));

export type ITemplateItem = typeof CQTemplateItem.Type;

